import { Typography } from '@mui/material'
import React from 'react'

export const ConcurrentTreeNodeSectionDescription: React.FC<{
  description: string
}> = ({ description }) => {
  return (
    <Typography
      sx={{
        marginLeft: 1,
        width: 650
      }}
    >
      {description}
    </Typography>
  )
}
